import React, { useState, useEffect } from 'react'
import api from '../api/api.register'
import { toast } from 'react-toastify'
import socketIOClient from 'socket.io-client'
import baseUrl from '../config.json'
import './style.css'
import SideBar from '../sidebar/sidebar'
import TopBar from '../topbar/topbar'
const ENDPOINT = baseUrl.apiEndPoint


function Register () {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [emailid, setEmailid] = useState('')
  const [roles, setRoles] = useState(['admin'])
  const [user, setUser] = useState([])

  useEffect(()=>{
    getUsers()
  },[])
  
  const getUsers = () =>  {
    api.getUser().then(res => {
     setUser(res.data)
    })
    }

  return (
    <div class='wrapper'>
      <SideBar />

      <div class='main-panel'>
        <TopBar />
        <div class='content'>
          <div class='container-fluid'>
            <div class='row'>
              <div class='col-lg-12 col-md-12'>
                <div class='card'>
                  <div class='header'>
                    <h5 class='title'>Create User</h5>
                  </div>
                  <div class='content' style={{ padding: '10px' }}>
                    <card class='table table-striped'>
                      <thead>
                        <tr>
                          <th>Username</th>
                          <th>Password</th>
                          <th>Email Id</th>
                          <th>Role</th>
                        </tr>
                      </thead>
                      {/* <div class="col-md-4"></div> */}

                      <tbody>
                        <tr>
                          {/* <div class="form-group"> */}
                          <td>
                            <input
                              type='text'
                              class='form-control border-input'
                              disabled=''
                              placeholder='Username'
                              value={username}
                              onChange={e => {
                                setUsername(e.target.value)
                              }}
                            ></input>
                          </td>
                          {/* </div> */}

                          {/* <div class="form-group"> */}
                          <td>
                            <input
                              type='password'
                              class='form-control border-input'
                              placeholder='Password'
                              value={password}
                              onChange={e => {
                                setPassword(e.target.value)
                              }}
                            ></input>
                          </td>
                          {/* </div> */}

                          {/* <div class="form-group"> */}
                          <td>
                            <input
                              type='text'
                              class='form-control border-input'
                              placeholder='Email Id'
                              value={emailid}
                              onChange={e => {
                                setEmailid(e.target.value)
                              }}
                            ></input>
                          </td>
                          {/* </div> */}

                          {/* <div class="form-group"> */}
                          <td>
                            <select
                              name='roles'
                              class='form-control border-input'
                              value={roles}
                              onChange={e => {
                                let roles = []
                                roles.push(e.target.value)
                                setRoles(roles)
                              }}
                            >
                              <option value='admin'>Admin</option>
                              <option value='user'>User</option>
                            </select>
                          </td>
                          {/* </div> */}

                          <td>
                            <div class='form-group'>
                              <div style={{ margin: '26px 0px' }}>
                                <button
                                  type='submit'
                                  class='btn btn-info btn-fill btn-wd'
                                  onClick={e => {
                                    //alert(createdby)
                                    e.preventDefault()
                                    if (username == '') {
                                      toast('Username is Mandatory ')
                                    } else if (password == '') {
                                      toast('Password is Mandatory ')
                                    } else if (emailid == '') {
                                      toast('Email Id is Mandatory ')
                                    } else {
                                      let data = {
                                        username: username,
                                        password: password,
                                        email: emailid,
                                        roles: roles
                                      }
                                      api.registerUser(data).then(res => {
                                        toast('Sucessfully Registered')
                                        setUsername('')
                                        setPassword('')
                                        setEmailid('')
                                        setRoles(['admin'])
                                        getUsers()
                                      })
                                    }
                                   
                                  }}
                                >
                                  Register
                                </button>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </card>
                  </div>
                </div>

                <div class='row'>
                  <div class='col-lg-12 col-md-12' style={{'padding': '0px 14px'}}>
                    <div class='card'>
                      <div class='header'>
                        <h5 class='title'>User Details</h5>
                      </div>
                      <div class='content table-responsive table-full-width'  >
                        {/* <card class="table table-striped"> */}

                        <table id='users' class='table tableextra' >
                          <thead>
                            <tr>
                              <th style={{'width':'300px'}}>Username</th>
                              <th style={{'width':'300px'}}>Email Id</th>
                              <th style={{'width':'200px'}}>Role</th>
                              <th>Reset Password</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              user.map((item)=>(
<tr>
                              
                              <td>{item.username}</td>
                              <td>{item.email}</td>
                              <td>{item.roles[0].name}</td>
                              <td>
                              <i
                              class='ti-pencil'
                              style={{ height: '35px' }}
                              onClick ={()=>{
                                window.location='/passwordreset/'+item._id
                              }}

                              >

                              </i>
                            </td>
                            </tr>
                              ))
                            }
                            
                          </tbody>
                        </table>
                        {/* </card> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Register
